// extracted by mini-css-extract-plugin
module.exports = {"qaItemsHolder":"QAItemList_qaItemsHolder__3hkm3","qaItemsHolderAttendee":"QAItemList_qaItemsHolderAttendee__DCnKS"};